'use client';

import { usePathname } from 'next/navigation';
import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import { ConsultationModal } from '@/components/ConsultationModal';
import { ContactSupportModal } from '@/components/ContactSupportModal';
import { InDevelopmentModal } from '@/components/InDevelopmentModal';
import { RouteChangeProgress } from '@/components/RouteChangeProgress';
import { useGlobals } from '@/contexts/GlobalsContext';
import { Footer } from '../Footer';
import { Header } from '../Header';
import styles from './Layout.module.scss';
const excludeFooterByUrl = ['/auth/registration', '/auth/reset-password', '/auth/reset-password/recovery', '/auth/sign-in', '/auth/create-password', '/auth/confirm-otp'];
export const Layout = ({
  children
}: PropsWithChildren) => {
  const {
    setShowConsultationModal,
    setShowContactSupportModal,
    setShowInDevelopmentModal,
    showConsultationModal,
    showContactSupportModal,
    showInDevelopmentModal
  } = useGlobals();
  const location = usePathname();
  const isHideFooterAndHeader = useMemo(() => excludeFooterByUrl.includes(location), [location]);
  const handleOpenChangeDevelopmentModal = () => {
    setShowInDevelopmentModal(prevState => !prevState);
  };
  const handleOpenChangeConsultationModal = () => {
    setShowConsultationModal(prevState => !prevState);
  };
  return <div className={styles.wrapper} data-sentry-component="Layout" data-sentry-source-file="Layout.tsx">
      <RouteChangeProgress data-sentry-element="RouteChangeProgress" data-sentry-source-file="Layout.tsx" />
      {!isHideFooterAndHeader && <Header />}
      <div className={styles.content}>{children}</div>
      {!isHideFooterAndHeader && <Footer />}
      <InDevelopmentModal onClose={handleOpenChangeDevelopmentModal} open={showInDevelopmentModal ?? false} data-sentry-element="InDevelopmentModal" data-sentry-source-file="Layout.tsx" />
      <ConsultationModal isOpen={showConsultationModal ?? false} onOpenChange={handleOpenChangeConsultationModal} data-sentry-element="ConsultationModal" data-sentry-source-file="Layout.tsx" />
      <ContactSupportModal isOpen={showContactSupportModal ?? false} setOpen={setShowContactSupportModal} data-sentry-element="ContactSupportModal" data-sentry-source-file="Layout.tsx" />
    </div>;
};